import React from 'react';
import { ConfigProvider } from 'antd';
import '../../styles/directOrders.css';

// Antd tokens for the Direct Orders section. Colours mirror the CSS variables in
// styles/directOrders.css. Nested inside the app-level ConfigProvider, so it only
// overrides what is listed here.
export const doThemeTokens = {
  token: {
    colorPrimary: '#2748d9',
    colorSuccess: '#12805c',
    colorWarning: '#b54708',
    colorError: '#c4321f',
    colorInfo: '#2748d9',
    colorText: '#101828',
    colorTextSecondary: '#667085',
    colorTextTertiary: '#667085',
    colorTextPlaceholder: '#98a2b3',
    colorBorder: '#d0d5dd',
    colorBorderSecondary: '#e4e7ec',
    colorBgLayout: '#f5f6f8',
    colorBgContainer: '#ffffff',
    fontFamily: "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    borderRadius: 6,
    borderRadiusLG: 8,
    controlHeight: 36,
    boxShadow: 'none',
    boxShadowSecondary: '0 8px 24px rgba(16, 24, 40, 0.12)',
  },
  components: {
    Button: {
      fontWeight: 500,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Table: {
      headerBg: '#ffffff',
      headerColor: '#667085',
      headerSplitColor: 'transparent',
      rowHoverBg: '#f9fafb',
      borderColor: '#e4e7ec',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
      bodySortBg: 'transparent',
      headerSortActiveBg: '#ffffff',
      headerSortHoverBg: '#f9fafb',
    },
    Tabs: {
      horizontalItemGutter: 28,
      titleFontSize: 14,
    },
    Segmented: {
      trackBg: '#eceef2',
      itemSelectedBg: '#ffffff',
    },
    Drawer: {
      colorBgElevated: '#ffffff',
    },
    Modal: {
      titleFontSize: 16,
    },
    Form: {
      labelColor: '#344054',
      verticalLabelPadding: '0 0 6px',
    },
  },
};

const DOTheme = ({ children }) => (
  <ConfigProvider theme={doThemeTokens}>{children}</ConfigProvider>
);

export default DOTheme;
